import React, {Component} from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import API_Root from '../../Constants/API_Root'
import API_Backend_Root from "../../Constants/API_Backend_Root";

class AgentsIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            agents: [],
            loading: false,
            error: null,
            accessKey: null,
            secretKey: null
        };
        this.handleCreateAgent = this.handleCreateAgent.bind(this);
        this.handleAgentClick = this.handleAgentClick.bind(this);
    }

    componentDidMount() {
        this.fetchAccountKeys();
    }

    // Helper method to get the correct API base URL
    getApiBaseUrl = () => {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            return 'http://127.0.0.1:8080/';
        }
        return "https://api.apispreadsheets.com/";
    }

    fetchAccountKeys = async () => {
        try {
            const userEmail = localStorage.getItem("email");
            const userToken = localStorage.getItem("token");
            
            if (!userEmail || !userToken) {
                this.setState({ 
                    error: "User authentication not found. Please log in again.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "fetch-account-keys/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: userEmail
                })
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    accessKey: data.access_key,
                    secretKey: data.secret_key
                }, () => {
                    // After setting the keys, fetch the user agents
                    this.fetchUserAgents();
                });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    error: errorData.error || "Failed to fetch account keys",
                    loading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching account keys:', error);
            this.setState({ 
                error: "Network error while fetching account keys",
                loading: false 
            });
        }
    }

    fetchUserAgents = async () => {
        try {
            this.setState({ loading: true, error: null });
            
            const { accessKey, secretKey } = this.state;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "get-user-agents/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify({})
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({ 
                    agents: data.agents || [],
                    loading: false 
                });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    error: errorData.error || "Failed to fetch agents",
                    loading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching user agents:', error);
            this.setState({ 
                error: "Network error while fetching agents",
                loading: false 
            });
        }
    }

    handleCreateAgent = () => {
        this.props.navigateTo('/ai/build-agent');
    }

    handleAgentClick = (agentHash) => {
        this.props.navigateTo(`/agent/${agentHash}`);
    }

    render() {
        return (
            <div style={{ padding: "24px 48px" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                    <h1 style={{ color: '#333', fontFamily: 'Lato', fontSize: '24px', fontWeight: '500' }}>AI Agents</h1>
                    <button
                        onClick={this.handleCreateAgent}
                        style={{
                            backgroundColor: '#70BB98',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            outline: 'none'
                        }}
                    >
                        Create Agent
                    </button>
                </div>

                {this.state.agents.length === 0 ? (
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '40px', 
                        color: '#666',
                        backgroundColor: '#f5f5f5',
                        borderRadius: '6px'
                    }}>
                        No agents found. Create your first agent to get started.
                    </div>
                ) : (
                    <div style={{ 
                        backgroundColor: 'white', 
                        borderRadius: '8px', 
                        border: '1px solid #e0e0e0',
                        overflow: 'hidden'
                    }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f8f9fa' }}>
                                    <th style={{ 
                                        padding: '16px', 
                                        textAlign: 'left', 
                                        fontWeight: '600', 
                                        color: '#333',
                                        borderBottom: '1px solid #e0e0e0'
                                    }}>
                                        Agent Name
                                    </th>
                                    <th style={{ 
                                        padding: '16px', 
                                        textAlign: 'left', 
                                        fontWeight: '600', 
                                        color: '#333',
                                        borderBottom: '1px solid #e0e0e0'
                                    }}>
                                        Agent ID
                                    </th>
                                    <th style={{ 
                                        padding: '16px', 
                                        textAlign: 'left', 
                                        fontWeight: '600', 
                                        color: '#333',
                                        borderBottom: '1px solid #e0e0e0'
                                    }}>
                                        Description
                                    </th>
                                    <th style={{ 
                                        padding: '16px', 
                                        textAlign: 'right', 
                                        fontWeight: '600', 
                                        color: '#333',
                                        borderBottom: '1px solid #e0e0e0'
                                    }}>
                                        Last Updated
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.agents.map(agent => (
                                    <tr 
                                        key={agent.id}
                                        onClick={() => this.handleAgentClick(agent.agent_hash)}
                                        style={{ 
                                            cursor: 'pointer',
                                            transition: 'background-color 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.closest('tr').style.backgroundColor = '#f8f9fa';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.closest('tr').style.backgroundColor = 'white';
                                        }}
                                    >
                                        <td style={{ 
                                            padding: '16px', 
                                            borderBottom: '1px solid #f0f0f0',
                                            fontWeight: '500',
                                            color: '#333'
                                        }}>
                                            {agent.agent_name}
                                        </td>
                                        <td style={{ 
                                            padding: '16px', 
                                            borderBottom: '1px solid #f0f0f0',
                                            fontFamily: 'monospace',
                                            fontSize: '12px',
                                            color: '#666'
                                        }}>
                                            {agent.agent_hash}
                                        </td>
                                        <td style={{ 
                                            padding: '16px', 
                                            borderBottom: '1px solid #f0f0f0',
                                            fontSize: '14px',
                                            color: '#333'
                                        }}>
                                            {agent.agent_desc || 'No description'}
                                        </td>
                                        <td style={{ 
                                            padding: '16px', 
                                            borderBottom: '1px solid #f0f0f0',
                                            fontSize: '12px',
                                            color: '#666',
                                            textAlign: 'right'
                                        }}>
                                            {new Date(agent.updated_dt).toLocaleDateString()}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}

const mapActionsToProps = {
    navigateTo: push
}

export default connect(null, mapActionsToProps)(AgentsIndex)
